import {Money} from './Money.js';

const floatMoney = (value) => {
    if (value === false || value === null || value === undefined) return 0.00;
    else if (typeof value !== 'string') return value;
    return (new Money).toFloat(value);
};
const toUpper = (value) => {
    if (!value) return '';
    return value.toString().toUpperCase();
};
const capitalize = (value) => {
    return value.charAt(0).toUpperCase() + value.slice(1);
};
const formatDate = (value) => {
    if (!value) return '';
    return moment(String(value)).format('DD-MM-YYYY');
};
const localizeMoney = (value) => {
    if (value === false || value === null || value === undefined) return '';
    else if (isNaN(value)) return value;
    return (new Money).localize(value);
};
const percent = (value) => {
    return localizeMoney(value) + '%';
};
const percentParticipation = (value) => {
    if (value === false || value === null || value === undefined) return '';
    else if (isNaN(value)) return value;
    return (new Money).localize(value);
}
const localizeExchangeRate = (value) => {
    return (new Money).localize(value, 4)
}

export default {
    floatMoney,
    toUpper,
    capitalize,
    formatDate,
    localizeMoney,
    percent,
    localizeExchangeRate,
    percentParticipation
};
